import {React, useState} from 'react';
import { useParams } from "react-router-dom";
import articles from "../articles.json";
import ReactMarkdown from 'react-markdown'
  import remarkGfm from 'remark-gfm'

const Articles = () => {
    const { articleUrl } = useParams();
      const [showSummary, setShowSummary] = useState(true);
    const article = articles.find((a) => a.url === `/${articleUrl}`);

    if (!article) return <h2>Article not found</h2>;


    // Format the article content
    const formattedContent = article.content
        .replace(/\/br/g, "<br />") // Convert "/br" to actual line breaks
        .replace(/\*([^*]+)\*/g, "<b>$1</b>"); // Convert *bold text* to <b>bold text</b>

    return (
        <div className="articlePage" style={{ left:0, right: "var(--sidebar-width, 306px)", position: "absolute" }}>
            <div className='whiteBarTop'></div>
            <div style={{ display: "flex", flexDirection: "column", width: "100%", justifyContent: "center", alignItems: "center"}}>
            <div style={{display:"flex", flexDirection: "column", width: "80%", alignSelf: "center", gap: 10}}>
            <div style={{ 
    width: "100%", 
    height: 300, 
    overflow: "hidden", 
    display: "flex",
    justifyContent: "center",
    marginTop: 20,

}}>
    <img 
        src={article.image} 
        alt={article.title} 
        style={{ 
            width: "100%", 
            objectFit: "cover", 
            borderRadius: "18px",
            boxShadow: "0px 10px 60px rgba(225.83, 236.19, 248.63, 0.50)"
        }} 
    />

</div>
<div style={{backgroundColor: "white", borderRadius: 18, padding: "20px 30px", boxShadow: "0px 10px 60px rgba(225.83, 236.19, 248.63, 0.50)"}}>
<h1 style={{zIndex: 100, position: "relative", fontSize: '1.75rem', /*background: "rgba(255, 255, 255, 0.7)",  background: "rgb(255, 255, 255)",*/
                padding: "5px 10px", textAlign: "left", width: "100%", margin: 0
            }}>{article.title}</h1><p style={{paddingLeft: 10, margin: 0, alignSelf: "left", textAlign: "left"}}>{article.type} | {article.date}</p></div>
            {showSummary && (
        <div className="gradientOutlineText" style={{cursor: "auto", backgroundColor: "white", borderRadius: 18, padding: "20px 30px", boxShadow: "0px 10px 60px rgba(225.83, 236.19, 248.63, 0.50)"}}>
            <p onClick={() => setShowSummary(false)} style={{cursor: "pointer",position: "absolute", top: 10, right: 20, margin: 0, zIndex: 1000, color: "#c180fb", fontSize: 18}}>x</p>
            <h3 style={{fontWeight: "bold", fontSize: 14, margin: 0, padding: 0, textAlign: "left"}}>AI Summary</h3>
            <p style={{fontSize: 12, margin: 0, paddingTop: 5, textAlign: "left",    whiteSpace: "pre-wrap", lineHeight: "1.3" }}>{article.aiSum}</p> 
            </div>    )}
<div style={{backgroundColor: "white", borderRadius: 18, padding: "20px 30px", boxShadow: "0px 10px 60px rgba(225.83, 236.19, 248.63, 0.50)", marginBottom: 20}}>
            
            
            
             
            <div style={{ top: 400, textAlign: 'left', left:0, right: 0 }}><ReactMarkdown remarkPlugins={[remarkGfm]}>{formattedContent}</ReactMarkdown></div>

            {/*<small>{article.date} | {article.type}</small>Render formatted content safely */}
            </div>
            </div>
        </div></div>
    );
};

export default Articles;
